import Margin from './component'

export default Margin
